<div mat-dialog-container
     class="error-dialog">
  <h2 mat-dialog-title
      class="error-dialog-title"
      translate="ERROR.ERROR_DETAILS"></h2>
  <mat-dialog-content class="error-dialog-content">
    <!-- Over budget errors -->
    <div *ngFor="let error of overBudgetErrors"
         class="error-dialog-item pop-display-flex">
      <i class="fas fa-exclamation-circle"></i>
      <div>
        <div>
          <span class="error-dialog-source-path">{{treePathToString(error.source)}}</span>
          <span class="error-dialog-source-path budget-source"
                [matTooltip]="'TOOLTIP.BUDGET_SOURCE' | translate">{{budgetFromGP ? 'GP' : 'POP'}}</span>
        </div>
        <div [translate]="error.errorMessage"
             [translateParams]="error.errorMessageParams"></div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="error-dialog-actions">
    <button mat-button
            [mat-dialog-close]="true"
            translate="BUTTON.OK"></button>
  </mat-dialog-actions>
</div>
